var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNoktasiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.33 119.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e3602d;}.cls-2{fill:#86c3b1;}.cls-3{fill:#f9ca70;}.cls-4{fill:#e78e26;}.cls-5{fill:none;stroke:#0d1c26;stroke-miterlimit:10;}.cls-6,.cls-7{fill:#0d1c26;}.cls-7{font-size:14.88px;font-family:CenturyGothic, Century Gothic;letter-spacing:0.5em;}.cls-8{fill:#ef8b22;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.55 94.33 74.11 0.14 101.42 94.31 46.55 94.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "156.79 0.14 178.81 75.4 200.38 0.14 156.79 0.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "11.74 94.33 39.94 0.14 66.93 94.33 11.74 94.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.55 94.31 103.27 79.61 126.53 0.14 153.52 94.31 107.55 94.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 228.74,
    y1: 0.14,
    x2: 255.85,
    y2: 94.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 132.7,
    y1: 0.14,
    x2: 159.82,
    y2: 94.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "118.23 57.79 143.1 57.91 126.66 0.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "12.74 94.33 0 94.33 27.92 0.14 40.66 0.14 12.74 94.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "176.8 94.31 164.06 94.31 191.74 0.14 204.48 0.14 176.8 94.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "57.07 57.79 50.91 36.39 61.56 0.14 74.31 0.14 57.07 57.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "103.3 79.62 96.93 57.91 113.91 0.14 126.66 0.14 103.3 79.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "195.89 94.31 223.41 0.14 250.4 94.31 195.89 94.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "215.11 57.79 239.98 57.91 223.53 0.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "195.89 94.31 183.12 94.31 210.79 0.14 223.53 0.14 195.89 94.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 66.93,
    y1: 94.33,
    x2: 40.47,
    y2: 0.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 178.59,
    y1: 75.4,
    x2: 157.02,
    y2: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 101.42,
    y1: 94.31,
    x2: 74.31,
    y2: 0.14
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(64.17 115.08)"
  }, "BUNGALOV"), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 42.51,
    cy: 109,
    r: 5.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 220.39,
    cy: 109.79,
    r: 5.29
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoktasiz);
export default __webpack_public_path__ + "static/media/logo_noktasiz.1244a2e4e7b8cecaecba793788c6abc2.svg";
export { ForwardRef as ReactComponent };